const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

export async function getTestimonial() {
  const res = await fetch(`${apiUrl}/api/testimonial-list`);
  return res.json();
}